import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import {Autocomplete, TextField }  from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useHistory } from "react-router-dom";

export default function FormDialog(props) {
    const [open, setOpen] = useState(false);
    const [selectedEquipment, setSelectedEquipment] = useState([])

    let history = useHistory();

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    const handleClose = () => {
        console.log("Closed the modal")
        props.closeCallback();
    };

    const handleSubmit = () => {
        props.addRelatedEquipmentCallback(selectedEquipment)
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Add Child Equipment</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {
                        "Choose children equipment from the existing equipment below."
                    }
                </DialogContentText>
                    <Autocomplete
                        id="spaces"
                        options={props.allEquipment || []}
                        getOptionLabel={option => option.name}
                        multiple={true}
                        isOptionEqualToValue={(option, value) => option.equipment_id === value.equipment_id}
                        renderInput={(params) => <TextField {...params} label="Select child equipment" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedEquipment(newValue);
                        }}
                    />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit}>Submit</Button>
            </DialogActions>
        </Dialog>
    )
}